const ROUTES = {    
    HOME: "/",
    // Linkroots
    LINKROOT: "/linkroot",
    LINKROOTUSER: "/linkroot-user",
    LINKROOTCOMPANY: "/linkroot-company",
    LINKROOTPRICING:"/linkroot-pricing",
    LINKROOT_DESCRIPTION:"/linkroot-description",
    LINKROOT_SERVER: "/linkroot-server",
    /*Auth*/
    LOGIN: "/login",
    REGISTER: "/register",
    FORGOT_PASSWORD: "/forgot-password",
    RESET_PASSWORD: "/reset-password",
    /*admin*/
    CREATEUSER: "/create-user",
    LISTUSER: "/list-user",
    EDITUSER: "/edit-user",  
    ADMINS: "/admins",
    CREATE_COMPANY: "/create-company",
    LIST_COMPANY: "/list-companies",
    EDIT_COMPANY: "/edit-company",
    /*user*/
    CALCULATOR: "/price-calculator",
    DESCRIPTIONS: "/descriptions",
    /*precios*/
    EDIT_HOURS_MATRIX: "/hours-matrix",
    LIST_PRICING_HOURS: "/list-pricing-hours",
    EDIT_PRICING_HOURS: "/edit-pricing-hours",
    /*Medidas de extencion*/
    LIST_EXTENSION_UNITS: "/list-extension-units",
    EDIT_EXTENSION_UNITS: "/edit-extension-unit",
    /*Nivel instruccional*/
    LIST_INSTRUCTIONAL_LEVELS: "/list-instructional-levels",
    EDIT_INSTRUCTIONAL_LEVELS: "/edit-instructional-level",
    /*Nivel multimedia*/
    LIST_MULTIMEDIA_LEVELS: "/list-multimedia-levels",
    EDIT_MULTIMEDIA_LEVELS: "/edit-multimedia-level",
    /*Servidor*/
    LOGS_VIEWER: "/logs-viewer",
    /*otras*/
    UNAUTHORIZED: "/unauthorized",
    CANCELAR: "/",
    HELLOWORLD: "/helloworld",
    SYSTEMINFO: "/systeminfo"
};

export default ROUTES;